import { __assign, __makeTemplateObject } from "tslib";
import { keyframes, LinearProgress, styled } from "@mui/material";
var Gradient = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        background-position: 0 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0 100%;\n    }\n"], ["\n    0% {\n        background-position: 0 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0 100%;\n    }\n"])));
export var StyledLinearProgress = styled(LinearProgress, {
    shouldForwardProp: function (prop) { return !['gradient'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, variant = _a.variant, gradient = _a.gradient;
    return (__assign({}, (gradient && __assign(__assign({}, (variant === 'determinate' && {
        backgroundColor: "#e2e2e2",
        '.MuiLinearProgress-bar ': {
            background: "linear-gradient(to right, #8346ff, ".concat(theme.palette.primary.main, ");")
        }
    })), (variant === 'indeterminate' && {
        '.MuiLinearProgress-bar ': {
            width: "100%",
            animation: "".concat(Gradient, " 2.1s linear infinite"),
            background: "linear-gradient(to right, ".concat(theme.palette.primary.main, ", ").concat(theme.palette.primary.main, " 7%, #6fc047 50%, ").concat(theme.palette.primary.main, ")"),
            backgroundSize: "200% 100%"
        }
    })))));
});
var templateObject_1;
//# sourceMappingURL=styled.js.map